
<div class="hover:cursor-pointer hover:shadow-lg transition-shadow duration-200">
<p-card>
    <ng-template #title>
        <div class="flex items-start justify-between">
            <a class="flex-grow min-w-0" [routerLink]="['/election/graphic/', election.id!]">
                <span class="text-lg font-bold truncate block">{{election.name}}</span>
                @if(daysRemaining != null && daysRemaining > 1) {
                    <span class="text-sm text-green-600">{{daysRemaining}} days remaining</span>
                } @else if (daysRemaining != null && daysRemaining == 1) {
                    <span class="text-sm text-orange-500">1 day remaining</span>
                } @else if (daysRemaining != null && daysRemaining == 0) {
                    <span class="text-sm text-orange-500">Election day</span>
                } @else if(daysRemaining != null && daysRemaining == -1) {
                    <span class="text-sm text-surface-400">1 day past end date</span>
                } @else if(daysRemaining != null && daysRemaining < -1) {
                    <span class="text-sm text-surface-400">{{daysRemaining * -1}} days past end date</span>
                }
            </a >
            @if(election.active) {
                <p-tag value="Active" severity="success"></p-tag>
            } @else {
                <p-tag value="Inactive" severity="secondary"></p-tag>
            }
        </div>
    </ng-template>

    <a class="space-y-3"  [routerLink]="['/election/graphic/', election.id!]">
      <div class="flex justify-between">
        <span class="text-sm font-medium text-surface-500">Result</span>
        <span class="text-sm">{{election.result?.result | campaignResult | titlecase}}</span>
      </div>
      <div class="flex justify-between">
        <span class="text-sm font-medium text-surface-500">Process Method</span>
        <span class="text-sm">{{election.processMethodLabel}}</span>
      </div>
      <div class="flex justify-between">
            <span class="text-sm font-medium text-surface-500">Type</span>
            <span class="text-sm">{{formattedType}}</span>
        </div>
        <div class="flex justify-between">
            <span class="text-sm font-medium text-surface-500">Date Range</span>
            <span class="text-sm">{{election.startDate | date:'mediumDate'}} - {{election.endDate | date:'mediumDate'}}</span>
        </div>
        <div>
            <div class="flex justify-between mb-1">
                <span class="text-xs text-surface-400">Timeline</span>
                <span class="text-xs text-surface-400">{{timelineProgress}}%</span>
            </div>
            <p-progressbar [value]="timelineProgress" [showValue]="false" [style]="{'height': '6px'}"></p-progressbar>
        </div>
    </a>

    <ng-template #footer>
        <div class="flex justify-between items-center pt-2">
            <div class="flex gap-1">
                @if (can.viewDashboard) {
                <a 
                    pTooltip="Dashboard" tooltipPosition="top"
                    [routerLink]="['/election/graphic/', election.id!]">
                    <span class="p-button-icon pi pi-chart-bar a-icon"></span>    
                </a>
                }
                @if (can.viewReports) {
                <a
                    pTooltip="Reports" tooltipPosition="top"
                    [routerLink]="['/election/report/', election.id!]">
                    <span class="p-button-icon pi pi-file a-icon"></span>    
                 </a>
                }
                @if (can.viewGroups) {
                <a
                    pTooltip="Groups" tooltipPosition="top"
                    [routerLink]="['/election/groups/', election.id!]">
                    <span class="p-button-icon pi pi-users a-icon"></span>   
                </a>
                }
                @if (can.upload) {
                <a
                    pTooltip="Upload Files" tooltipPosition="top"
                    [routerLink]="['/upload/', election.id!]">
                   <span class="p-button-icon pi pi-upload a-icon"></span>    
                </a>
                }
                @if (can.manageCampaignUsers) {
                <a 
                    pTooltip="Election Users" tooltipPosition="top"
                    [routerLink]="['/election/associate-user/', election.id!]">
                   <span class="p-button-icon pi pi-user a-icon"></span>                      
                 </a>
                }
            </div>
            @if (can.editCampaignDetails) {
            <a
                pTooltip="Settings" tooltipPosition="top"
                [routerLink]="['/election/edit/', election.id!]">
                <span class="p-button-icon pi pi-cog a-icon"></span>
            </a>
            } @else if (can.viewDetails) {
            <a
                pTooltip="Details" tooltipPosition="top"
                [routerLink]="['/election/', election.id!]">
                <span class="p-button-icon pi pi-info-circle a-icon"></span>
            </a>
            }
        </div>
    </ng-template>
</p-card>
</div>
